import { render, staticRenderFns } from "./CopyDrawer.vue?vue&type=template&id=4d058941&scoped=true"
import script from "./CopyDrawer.vue?vue&type=script&lang=js"
export * from "./CopyDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d058941",
  null
  
)

export default component.exports